import Icon from "@/components/ui/Icon";

export default function MobileCTA() {
  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 md:hidden flex p-3 gap-2 bg-white/95 backdrop-blur-md border-t border-stone-100">
      <a
        href="tel:+905362771709"
        className="flex-1 flex items-center justify-center gap-2 bg-[#1a3d2b] text-[#a8d5b5] font-bold py-3.5 rounded-full text-sm cursor-pointer whitespace-nowrap"
      >
        <Icon name="ri-phone-fill" className="text-base" />
        Hemen Ara
      </a>
      <a
        href="https://wa.me/905362771709"
        target="_blank"
        rel="nofollow noopener noreferrer"
        className="flex-1 flex items-center justify-center gap-2 bg-green-600 text-white font-bold py-3.5 rounded-full text-sm cursor-pointer whitespace-nowrap"
      >
        <Icon name="ri-whatsapp-fill" className="text-base" />
        WhatsApp
      </a>
    </div>
  );
}
